import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { LIST_MONEY_ACCOUNTS_RESOURCE } from 'src/features/moneyAccounts/api/useListMoneyAccounts';
import { useCreateMoneyAccount } from 'src/features/moneyAccounts/api/useCreateMoneyAccount';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';
import { MoneyAccount } from 'src/features/moneyAccounts/utils/types';
import MoneyAccountFormModal from 'src/features/moneyAccounts/components/forms/MoneyAccountFormModal';

interface CreateMoneyAccountFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedBankAccount?: MoneyAccount;
    children?: React.ReactNode;
}

function CreateMoneyAccountFormModal<TData>({ className, semantics }: CreateMoneyAccountFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateMoneyAccount({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_MONEY_ACCOUNTS_RESOURCE] });
            toast({
                title: formatMessage(moneyAccountsMessages.createMoneyAccountSuccess),
                description: formatMessage(moneyAccountsMessages.createMoneyAccountSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <MoneyAccountFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(moneyAccountsMessages.addMoneyAccountSubtitle)}
        />
    );
}

export default CreateMoneyAccountFormModal;
